const { contractsValidationsErrorMessages } = require('constants/contractsValidations');
const {
    EURO_SYMBOL,
    INTERVENER_LABEL_HOLDER,
    INTERVENER_LABEL_AUTHORIZED,
    INTERVENER_LABEL_EMPOWERED
} = require('constants/index');

module.exports = {
    title: 'contractsView-contractsView_noNewMoneyDepositStep2Title',
    order: 2,
    footer_text: '',
    disableNext: 'combinedDeposit_nextButtonDisabled',
    position: 'middle',
    components:
        [
            {
                id_component: 'dropdown-accounts',
                label: 'contractsView-contractsView_noNewMoneyDepositStep2Account',
                options: [],
                type: 'single',
                target: 'cta_seleccionada',
                targetIntervener: 'intervinientes_list',
                intervenersSpecial: true,
                order: 1,
                isIntervenerAvailable: true,
                renderInterveners: 'combinedDeposit_shouldBuild',
                isMaxAmountLabelAvailable: false,
                intervenersHeader: 'contractsView-contractsView_noNewMoneyDepositIntervenersHeader',
                maxAmountValue: 0,
                required: true,
                errorMessage: contractsValidationsErrorMessages.ERROR_MESSAGE_REQUIRED_DROPDOWN_ACCOUNTS_DEPOSIT_THIRTEEN,
                accountChangeExtraFn: 'refreshNoNewMoneyDepositHireInformation',
                intervenersHierarchicalTypeSelection: true,
                intervenerOptions: [
                    INTERVENER_LABEL_HOLDER,
                    INTERVENER_LABEL_AUTHORIZED,
                    INTERVENER_LABEL_EMPOWERED
                ],
                showIntervenerControls: true,
                restoreDefaultIntervenersEnabled: true
            },
            {
                id_component: 'slider',
                label: 'contractsView-contractsView_noNewMoneyDepositStep2Amount',
                min_value: 0,// is populated by service
                max_value: 0,// is populated by service
                default_value: 0,// is populated by service
                value: null,// is populated by service
                type: 'single',
                format_type: EURO_SYMBOL,
                inputType: 'float',
                onChangeFn: 'combinedDeposit_onChangeAmount',
                is_money: true,
                title: 'contractsView-amountTitle',
                target: 'monto_traspasar',
                source: 'combinedDeposit_loadSliderAmounts',
                tooltipNoPadding: true,
                buildCondition: 'combinedDeposit_shouldBuild'
            },
            {
                id_component: 'checkbox',
                id: 'renewDeposit',
                target: 'renewDeposit',
                label: 'contractsView-contractsView_noNewMoneyDepositStep2Renew',
                type: 'single',
                value: false,
                onChangeFn: 'combinedDeposit_onChangeCheckbox',
                buildCondition: 'combinedDeposit_shouldBuild'
            },
            {
                id_component: 'validation-modal',
                id: 'validationModal',
                title: 'contractsView-contractsView_noNewMoneyDepositStep2ValidationModalTitle',
                content: 'combinedDeposit_FinalModalChildren',
                allowContinue: true,
                open: 'combinedDeposit_showFinalModal',
                showCloseButton: false,
                leaveButtonText: 'contractsView-contractsView_noNewMoneyDepositBackButtonModal'
            },
            {
                id_component: 'disclaimer-personal-info',
                messageKey: 'disclaimerPersonalInfo_combinedDepositMsg',
                linkTextKey: 'disclaimerPersonalInfo_combinedDepositLinkText',
                linkUrlKey: 'disclaimerPersonalInfo_combinedDepositLinkUrl'
            }
        ]
};
